import { Typography } from '@mui/material'
import { useScreenSize } from '../../../../hooks/useScreenSize'
import { getDaysUntilNextTarget } from '../../utils'

export const WeeklyCountdown = () => {
    const { isMobile } = useScreenSize()

    const daysUntilNextTarget = getDaysUntilNextTarget(new Date(), 1, 7) // Monday at 7 AM UTC

    return (
        <Typography textAlign="center" textTransform="uppercase" variant={isMobile ? 'h6' : 'h5'}>
            ALL MISSIONS COMPLETED <br />
            New available in {daysUntilNextTarget} day{daysUntilNextTarget > 1 ? 's' : ''}
        </Typography>
    )
}
